/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/10/26
 */
import './index.css';
import PropTypes from 'prop-types';
import React,{Component, isValidElement} from 'react';
import classname from 'classname';
import ScrollInView from '../../../utils/scrollInView';

class Image extends Component {
  static propTypes = {
    src: PropTypes.string.isRequired,
    base: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    alt: PropTypes.string,
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    style: PropTypes.object
  };
  constructor (props) {
    super(props);
    this.state = {
      load: false
    };
    const { src } = this.props;
    if (src) {
      this.src = src;
      setTimeout(this.handleScrollInView.bind(this), 0);
    }
  }
  handleScrollInView () {
    if (this.scrollInView) {
      return this.scrollInView;
    }
    this.scrollInView = new ScrollInView(this.refs.image, true);
    this.scrollInView.on('in', this.loadImage.bind(this));
  }
  loadImage () {
    const img = new window.Image();
    img.onload = () => {
      this.setState({
        load: true
      });
    };
    img.src = this.src;
  }
  componentWillReceiveProps (nextProps) {
    if (nextProps.src) {
      this.src = nextProps.src;
      this.handleScrollInView();
    }
  }
  componentWillUnmount() {
    if (this.scrollInView) {
      this.scrollInView.removeListener();
    }
  }
  render () {
    const {base, src, alt = " ", className, ...others} = this.props;
    const classNames = classname('store-image', className);
    return <span {...others} className={classNames} ref="image">
      {this.state.load
        ? <img src={src} alt={alt} />
        : isValidElement(base)
          ? base
          : <img src={base} alt={alt} />
      }
    </span>
  }
}

export default Image;



// WEBPACK FOOTER //
// ./src/components/lib/image/index.js